gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
document.addEventListener('DOMContentLoaded', () => {
    //home sec 7

    document.querySelectorAll('.co-pi-s2').forEach(item => {
        let itemImg = item.querySelector('.co-pi-s2--media img');
        imageScrollParallax(itemImg, item, "20%", 'bottom', 0, 15);
    });



    var coHS7splide = new Splide('.co-home-s7-swiper', {
        type: 'loop',
        drag: 'free',
        autoWidth: true,
        snap: true,
        speed: 1200,
        focus: 'center',
        updateOnMove: true,
        start: 3,
    });

    coHS7splide.mount();

    //home sec 10
    gsap.set('.co-home-s10-accordion-item', { opacity: 0, y: 40 });
    let chs10 = gsap.timeline({ paused: true });
    chs10.to('.co-home-s10-accordion-item', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-home-s10-accordion-item',
        start: "40% bottom",
        end: "bottom top",
        animation: chs10
    });
    //Simple Accordion
    var coAccItemsS10 = document.querySelectorAll(".co-home-s10-accordion--title");
    coAccItemsS10.forEach(function (groupItem, index) {
        var nextElement = groupItem.nextElementSibling;
        if (index === 0 || groupItem.classList.contains("active")) {
            groupItem.classList.add("active");
            nextElement.classList.add("active");

            gsap.to(nextElement, {
                height: "auto",
                duration: 0.3,
                ease: "power2.inOut",
            });
        } else {
            nextElement.classList.remove("active");
            gsap.to(nextElement, {
                height: 0,
                duration: 0.3,
                ease: "power2.inOut",
            });
        }

        groupItem.addEventListener("click", function (e) {
            e.preventDefault();
            // Check if the parent element already has the 'active' class
            if (!this.classList.contains("active")) {
                // If not active, hide all other sections
                coAccItemsS10.forEach(function (otherAccItem, otherIndex) {
                    otherAccItem.classList.remove("active");
                    otherAccItem.nextElementSibling.classList.remove("active");

                    gsap.to(otherAccItem.nextElementSibling, {
                        height: 0,
                        duration: 0.3,
                        ease: "power2.inOut",
                    });
                });
                // Add 'active' class to the clicked item and show its content
                this.classList.add("active");
                nextElement.classList.add("active");
                gsap.to(nextElement, {
                    height: "auto",
                    duration: 0.3,
                    ease: "power2.inOut",
                });
            } else {
                // remove 'active' if clicked on 'active'
                this.classList.remove("active");
                nextElement.classList.remove("active");
                gsap.to(nextElement, {
                    height: 0,
                    duration: 0.3,
                    ease: "power2.inOut",
                });
            }

            ScrollTrigger.refresh(true)
            // If already active, don't hide the content
        });


    });

    coAccItemsS10.forEach(function (item, index) {
        if (index >= 3) {
            item.closest('.co-home-s10-accordion-item').classList.add('hidden');
        }
    });

    coBtnMore = document.querySelector('.co-home-s10-accordion--more');
    coBtnMore.addEventListener('click', function (e) {
        e.preventDefault();
        coAccItemsS10.forEach(function (item, index) {
            item.closest('.co-home-s10-accordion-item').style.animationDelay = '0.1' + index * 10 + 's';
            item.closest('.co-home-s10-accordion-item').classList.remove('hidden');
            item.closest('.co-home-s10-accordion-item').classList.add('visible');
            coBtnMore.style.display = 'none';
        });
        ScrollTrigger.refresh(true)
    });

    //sec 10
    // footerReveal();
});


